import { Popup } from '../../../../../ui/popup/popup';
import { getTexts } from '../../domain/free-with-your-purchase-provider';
import { useAppSelector } from '../../data/store';

interface IFreeWithYourPurchasePopup {
    setPopupVisible: Function,
}

const FreeWithYourPurchasePopup = (props: IFreeWithYourPurchasePopup) => {

    const cartData = useAppSelector(store => store.root.cartData);
    const { freeWithPurchaseType } = cartData;

    const closeHandler = () => {
        props.setPopupVisible(false);
    };

    const { title, content } = getTexts(freeWithPurchaseType);

    return (
        <Popup width="400px" height="270px" close={ closeHandler }>
            <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">

                <p className="mb-2 text-xl">{ title }</p>
                <p className="mb-4 px-6">{ content }</p>

                <button
                    type="button"
                    className="w-btn"
                    onClick={ closeHandler }
                    style={{ width: '170px' }}>OK</button>
            </div>
        </Popup>
    )
};

export default FreeWithYourPurchasePopup;